
import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { getDepartmentList } from "@/api/company";
import { getPartsList } from "@/api/parts";
import { addGroupView, editGroupView } from "@/api/group";
import GroupFault from '@/views/groups/components/GroupFault.vue';

@Component({
  name: "AddPhenomenonGroup",
  components: {
    GroupFault,
  },
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  dialogPartsGroupsVisible: any;
  @Prop({
    type: Object,
    default:{ 
        group_name: '',
      },
  })
  editorData!: any ;

  private active = 0

  private selectFault: any=[]; 
  private remindTime:any = {
    unfinish_task_timeout_remind_hours: '',
    unfinish_task_timeout_remind_minutes: '',
    unfinish_task_timeout_remind_hours_ahead: '',
    unfinish_task_timeout_remind_minutes_ahead: '',
  };

  private hoursOptions:any=[]
  private minutesOptions:any=[]

  created() {

    for (var m = 0; m < 721; m++) {
      this.hoursOptions.push(m);
    }
    var min = 0;
    this.minutesOptions.push(min);
    for (var i = 0; i < 11; i++) {
      min = min + 5;
      this.minutesOptions.push(min);
    }
    //通过传来的值
    if(this.editorData && this.editorData.id){
      this.selectFault = this.editorData.falut_list;
      this.remindTime = this.editorData.time_list.unfinish_task_timeout;
    }
  }
  private selectBlurUnfinishTaskTimeout(e:any) {
    this.remindTime.unfinish_task_timeout_remind_hours = e.target.value;
  }
  private selectBlurUnfinishTaskTimeoutAhead(e:any) {
    this.remindTime.unfinish_task_timeout_remind_hours_ahead = e.target.value;
  }
  private nextStep() {
    if (this.active === 1) {
      if (!this.selectFault || this.selectFault.length < 1) {
        this.showErrorMsg('请选择故障现象')
        return
      }
      this.active = 2;
      // if (!(this.partsData && this.partsData.length > 0)) {
      //   this.getPartsList()
      // }
    }
    if (this.active === 0) {
      (this.$refs.formName as any).validate((valid: any) => {
        if (valid) {
          this.active = 1
        } else {
          return false;
        }
      });
    }
  }
  private uptStep() {
    if (this.active === 2) {
      this.active = 1
    } else {
      this.active = 0
    }
  }

  private checkedFaultChange(val:any) {
    this.selectFault = val;
  }
  private confirmHandle() {
    //最后检查超时时长设置
    if ( !this.remindTime.unfinish_task_timeout_remind_hours &&  !this.remindTime.unfinish_task_timeout_remind_minutes) {
      this.showErrorMsg('请设置任务未完成超时时长')
      return
    }
    this.addGroup(this.editorData && this.editorData.id)
  }
  private addGroup(isEditor:boolean) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      group_type: 31,
      group_name: this.editorData.group_name,
    };
    let faults:any = []
    this.selectFault.forEach((element:any) => {
      let dept = {
        id: element.id,
        name: element.name
      }
      faults.push(dept)
    });
    // let parts:any = []
    // this.remindTime.forEach((element:any) => {
    //   let part = {
    //     id: element.id,
    //     name: element.name
    //   }
    //   parts.push(part)
    // });
    let timeout =  {'unfinish_task_timeout':this.remindTime}
    params.faults = JSON.stringify(faults)
    params.timeout = JSON.stringify(timeout)
    if (isEditor) {
      params.group_id = this.editorData.id
      editGroupView(params).then((res:any) => {
        this.showSuccessMsg(res.msg)
        this.close(true)
      }).catch(err => {
        this.showErrorMsg(err.msg);
      })
    } else {
      addGroupView(params).then((res:any) => {
        this.showSuccessMsg(res.msg)
        this.close(true)
      }).catch(err => {
        this.showErrorMsg(err.msg);
      })
    }
  }
  
  close(refresh: boolean) {
    this.$emit('close', false, refresh);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
